import { format } from "date-fns";
const datePlus60 = format(
  new Date().setDate(new Date().getDate() + 60),
  "yyyy-MM-dd"
);
const date = format(new Date(), "yyyy-MM-dd");

export const invoiceJson = {
  Id: "",
  Contact_Id: "",
  Deal_Id: "",
  Application_Id: "",
  Invoice_Type_Id: "",
  Referral_No: "",
  Created_On: "",
  Created_By: "",
  Modified_On: "",
  Modified_By: "",
  Active: "1",
  Invoice_Status: "",
  Invoice_Due_Date: datePlus60,
  Payment_Due_Date: datePlus60,
  Invoice_Date: date,
  ContactName: "",
  DealName: "",
  ApplicationId: "",
  Currency: "",
  CurrencyValue: "0",
};

export const invoiceDetailJson = {
  Id: "",
  Invoice_Id: "0",
  Country_Id: "",
  Tuition_Fees: "0",
  Enrollment_Fees: "0",
  Material_Cost: "0",
  COE_Fees: "0",
  Other_Fees: "0",
  Description: "",
  Commisionable_Amount: "0",
  Comission_percent: "0",
  Comission_Amount: "0",
  Comission_GST: "0",
  Sub_Total: "0",
  OC_Amount: "0",
  OC_Amount_B: "0",
  OC_Description: "",
  OC_GST: "0",
  F_Sub_Total: "0",
  Total_with_GST: "0",
  Total_GST: "0",
  Payable_To_College: "0",
  Medium_Type: "0",
  Medium_Description: "",
  Created_On: "0",
  Created_By: "",
  Modified_On: "0",
  Modified_By: "",
  Active: "1",
  Total_Tuition_Fees: "0",
  Total_Material_Fees: "0",
  Total_Enrollment_Fees: "0",
  Selected_Terms: "0",
  Tuition_Fess_Collected: "0",
  Enrollment_Fees_Collected: "0",
  Material_Cost_Collected: "0",
  Include_Gst_C: "0",
  Gst_C: "0",
  OC_Include_Gst_C: "0",
  OC_Gst_C: "0",
  OC_Amount1: 0,
  OC_Amount_B1: "0",
  OC_Description1: "",
  OC_GST1: "0",
  OC_Include_Gst_C1: "0",
  OC_Gst_C1: "0",
  OC_Amount2: "0",
  OC_Amount_B2: "0",
  OC_Description2: "",
  OC_GST2: "0",
  OC_Include_Gst_C2: "0",
  OC_Gst_C2: "0",
  
};

export const invoiceSearchJson = {
  university: "",
  invoiceStatus: "",
  invoiceFrom: "",
  invoiceTo: "",
  searchtxt: "",
  pageSize: 25,
  pageNo: 1,
  createdFrom: "",
  createdTo: "",
  paymentFrom: "",
  paymentTo: "",
  branchId: "",
  countryId: "",
  destinationId: "",
  partnerId: "",
  subagentId: "",
};

export const subagentInvoiceJson = {
  Contact_Id: "",
  Invoice_Id: "",
  Application_Id: "",
  InvoiceRaised_Date: "",
  InvoiceRaised_Amount: "",
  Subagent_Id: "",
  Invoice_Due_Date: "",
  Invoice_Due_Amount: "",
};

export const subagentInternalInvoiceJson = {
  SubAgent_Id: "",
  Invoice_Id: "",
  Paid_To_Subagent: "",
  Paid_Date: "",
  Any_Comments: "",
};
